<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";

</script>

<Card>
    <CardBody>
        <div class="mb-4 h1 card-title">More Information</div>
        <div>
          
          <p class="card-text">
            for more information, please visit <a href="https://huggingface.co/datasets/lawcompany/KLAID">Huggingface page</a>
        </div>
      </CardBody>
</Card>